import { render, staticRenderFns } from "./MarketingEmailFormModelsSection.vue?vue&type=template&id=7636b0cd&scoped=true"
import script from "./MarketingEmailFormModelsSection.vue?vue&type=script&lang=js"
export * from "./MarketingEmailFormModelsSection.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailFormModelsSection.vue?vue&type=style&index=0&id=7636b0cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636b0cd",
  null
  
)

export default component.exports